import pro1 from '../../pic/gym-girl.jpg'
import pro2 from "../../pic/todo.jpg";
import pro3 from "../../pic/imdb.jpg";
import pro4 from "../../pic/pfolio.jpg";
import pro5 from "../../pic/calcu.jpg";
import pro6 from '../../pic/login.webp'
import pro7 from "../../pic/Dash.webp";
const ProjectCard =[
    {
        imgsrc: pro1,
        title:"City Gym Website",
        text:"It Is A Web-Page Layout About Gym ",
        view:"https://citygym.pages.dev/"
    },
    {
        imgsrc: pro2,
        title:"To-Do List",
        text:"It Is A To-do List for making notes ",
        view:"https://todo-2cx.pages.dev/"
    },
    {
        imgsrc: pro3,
        title:"imdb clone app",
        text:"It Is A Clone Of Imdb ",
        view:"https://imdb-f1l.pages.dev/"
    },
    {
        imgsrc: pro4,
        title:"Portfolio",
        text:"It Is About My Portfolio ",
        view:"https://myportfolio-psi-kohl.vercel.app/"
    },
    {   
        imgsrc: pro5,
        title:"calculator",
        text:"It is calculator App",
        view:"https://calculator-omega-wine.vercel.app/"     
    } ,
    {
        imgsrc:pro6,
        title:"login",
        text:"Login Logout using local storage",
        view:"https://logio.vercel.app/"
    },
      {
        imgsrc:pro7,
        title:"Dash-Board",
        text:"Shopping-Dashboard App",
        view:"https://shop-dashboard-nu.vercel.app/"
    }
];
export default ProjectCard;
